import galleryCard1 from "../assets/images/webp/main-gallery-card-1.webp";
import galleryCard2 from "../assets/images/webp/main-gallery-card-2.webp";
import galleryCard3 from "../assets/images/webp/main-gallery-card-3.webp";
import galleryCard4 from "../assets/images/webp/main-gallery-card-4.webp";
import galleryCard5 from "../assets/images/webp/main-gallery-card-5.webp";
import galleryCard6 from "../assets/images/webp/main-gallery-card-6.webp";
import galleryCard7 from "../assets/images/webp/main-gallery-card-7.webp";
import galleryCard8 from "../assets/images/webp/main-gallery-card-8.webp";
import galleryCard9 from "../assets/images/webp/main-gallery-card-9.webp";
import galleryCard10 from "../assets/images/webp/main-gallery-card-10.webp";
import galleryCard11 from "../assets/images/webp/main-gallery-card-11.webp";
import galleryCard12 from "../assets/images/webp/main-gallery-card-12.webp";
export const galleryDetails = [
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard1,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard2,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard3,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard4,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard5,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard6,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard7,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard8,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard9,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard10,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard11,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard12,
  },

  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard2,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard8,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard3,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard4,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard5,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard11,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard10,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard6,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard1,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard12,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard7,
  },

  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard9,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard4,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard5,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard11,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard10,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard6,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard1,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard12,
  },
  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard7,
  },

  {
    uploadedOn: "",
    imageName: "",
    timeStamp: "",
    url: galleryCard9,
  },
];
